import { WithStyles } from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { openMainMenu, setTsqWindow } from '../actions/mainMenu';
import { IUserAttr } from '../actions/session';
import envelopeImage from '../images/menu/envelope.png';
import learnerHelpImage from '../images/menu/learner-help.png';
import manageImage from '../images/menu/manage.png';
import personalImage from '../images/menu/personal.png';
import processImage from '../images/menu/process.png';
import searchImage from '../images/menu/search.png';
import skillInfoImage from '../images/menu/skill-info.png';
import userInfoImage from '../images/menu/user-info.png';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import ScenarioFactory from '../scenario/MainMenuScenarioFactory';
import NavbarScenarioFactory from '../scenario/NavbarScenarioFactory';
import Config from '../site.config.json';
import { isMobile } from '../utils/MobileCheck';
import { Routes, Screens } from '../utils/Routes';

const styles = (theme: Theme) =>
	createStyles({
		menuIcon: {
			height: '40px',
			width: '40px',
		},
	});

interface IMenu {
	header?: string;
	id?: string;
	items: IItem[];
}

interface IItem {
	id?: string;
	link?: () => void;
	mobile: boolean;
	title: string;
	icon: any;
}

/**
 * Windowオブジェクトを拡張してTSQに渡すプロパティを追加
 */
type TsqWindow = Window & {
	/**
	 * ログインURL
	 */
	lmLoginPath?: string;
	/**
	 * 閲覧用URL
	 */
	lmPreviewPath?: string;
	/**
	 * ログアウトURL
	 */
	lmLogoutPath?: string;
	/**
	 * ログインタイプ
	 */
	lmLoginType?: string;
};

interface IState {
	disableAdminPageItem: boolean;
}

/**
 * メインメニュー
 */
class MainMenu extends React.Component<IProps, IState> {
	protected menus: JSX.Element;

	constructor(props: IProps) {
		super(props);

		this.state = {
			disableAdminPageItem: false,
		};
	}

	/**
	 * Lifecycle Methods
	 */
	public componentDidMount() {
		this.props.fetchMenuModel(this.props.token);
	}

	public render() {
		const { classes, open } = this.props;
		const p = (s: Screens) => () => this.props.pushHistory(s);
		const { permittedItems } = this.props;
		const enableDataUpdate =
			this.props.userAttr.authorityList.indexOf(
				'PER_QUICKMODE_DATAUPDATE'
			) === -1;
		const enableContentScreate =
			this.props.userAttr.authorityList.indexOf(
				'PER_QUICKMODE_CONTENTSCREATE'
			) === -1;
		const enableContentScutoff =
			this.props.userAttr.authorityList.indexOf(
				'PER_QUICKMODE_CONTENTSCUTOFF'
			) === -1;
		const quickModeDisabled =
			(!enableDataUpdate &&
				!enableContentScreate &&
				!enableContentScutoff) ||
			(!enableContentScreate && isMobile());
		return (
			<SwipeableDrawer
				open={open}
				onOpen={this.props.openMainMenu}
				onClose={this.props.closeMainMenu}
			>
				<this.Menus />
				{permittedItems.findIndex(e => e === 'M_PER_QUICKMODE') !==
					-1 &&
					!quickModeDisabled && (
						<List
							component="nav"
							onClick={this.props.closeMainMenu}
						>
							<ListItem
								button={true}
								onClick={p(Screens.QUICK_MODE)}
							>
								<img
									src={manageImage}
									className={classes.menuIcon}
								/>
								<ListItemText
									primary={i18n.t('Rakunavi_Name')}
								/>
							</ListItem>
						</List>
					)}

				{this.props.managerChk !== '0' && !isMobile() && (
					<List component="nav" onClick={this.props.closeMainMenu}>
						<ListItem
							button={true}
							onClick={this.openAdminPage}
							disabled={this.state.disableAdminPageItem}
						>
							<img
								src={manageImage}
								className={classes.menuIcon}
							/>
							<ListItemText primary={i18n.t('MainMenu_0001')} />
						</ListItem>
					</List>
				)}
			</SwipeableDrawer>
		);
	}

	/**
	 * 管理者ウィンドウ表示
	 */
	protected openAdminPage = () => {
		// 新しくウィンドウを開く場合はセッションの死活チェックをしてから
		this.setState({ disableAdminPageItem: true });
		this.props
			.checkSession(this.props.token)
			.then(() => {
				if (
					this.props.tsqWindow &&
					this.props.tsqWindow.closed === false
				) {
					this.props.tsqWindow.focus();
					this.setState({ disableAdminPageItem: false });
					return;
				}
				const tsqWindow: TsqWindow | null = window.open(
					Config.tsqPath + '/pkg/index.html',
					'_blank'
				);
				if (tsqWindow) {
					const f = () => {
						tsqWindow.lmLoginPath =
							window.location.origin +
							Routes.getPath(Screens.LOGIN);
						tsqWindow.lmPreviewPath =
							window.location.origin +
							Routes.getPath(Screens.ELEARNING_PREVIEW);
						tsqWindow.lmLogoutPath =
							window.location.origin +
							Routes.getPath(Screens.LOGOUT);
						tsqWindow.lmLoginType = this.props.userAttr.loginType;
					};
					const userAgent = window.navigator.userAgent.toLowerCase();
					if (
						userAgent.indexOf('msie') > -1 ||
						userAgent.indexOf('trident') > -1
					) {
						// IEではウェイトをいれないと子ウィンドウに渡した変数が消えてしまう
						window.setTimeout(f, 1000);
					} else {
						f();
					}
					window.addEventListener(
						'message',
						event => {
							if (event.data === 'logout') {
								this.props.logout(
									this.props.token,
									this.props.tsqWindow,
									this.props.userAttr
								);
							}
						},
						false
					);
				}
				this.props.setTsqWindow(tsqWindow);
				this.setState({ disableAdminPageItem: false });
			})
			.catch(() => {
				/* エラーメッセージはシナリオ内で表示 */
			});
	};

	/**
	 * メニュー一覧コンポーネント
	 */
	protected Menus: React.FC = _ => {
		const p = (s: Screens) => () => this.props.pushHistory(s);
		const { classes } = this.props;
		const menuTypes: IMenu[] = [
			{
				items: [
					{
						icon: personalImage,
						mobile: true,
						title: i18n.t('MainMenu_0002'),
					},
				],
			},
			{
				id: 'M_PER',
				items: [
					{
						icon: envelopeImage,
						id: 'M_PER_NOTICE',
						link: p(Screens.PERSONAL_PORTAL),
						mobile: true,
						title: i18n.t('MainMenu_0003'),
					},
					{
						icon: searchImage,
						id: 'M_PER_SEARCH',
						link: p(Screens.PERSONAL_SEARCH),
						mobile: true,
						title: i18n.t('MainMenu_0004'),
					},
					{
						icon: processImage,
						id: 'M_PER_IMSTAT_ONGELWINDOW',
						link: p(Screens.PERSONAL_STATUS),
						mobile: true,
						title: i18n.t('MainMenu_0005'),
					},
					{
						icon: skillInfoImage,
						id: 'M_PER_SKILL_ONGSKILLWINDOW',
						link: p(Screens.PERSONAL_SKILL),
						mobile: false,
						title: i18n.t('MainMenu_0006'),
					},
				],
			},
			{
				id: 'M_HELP',
				items: [
					{
						icon: userInfoImage,
						id: 'M_PER_USER',
						link: p(Screens.PERSONAL_PROFILE),
						mobile: true,
						title: i18n.t('MainMenu_0007'),
					},
					{
						icon: learnerHelpImage,
						id: 'M_HELP_MAN_STUDENT_M',
						link: p(Screens.HELP_PARTICIPANT),
						mobile: false,
						title: i18n.t('MainMenu_0008'),
					},
					{
						icon: learnerHelpImage,
						id: 'M_HELP_MAN_STUDENT_M_CM',
						link: p(Screens.HELP_PARTICIPANT_CM),
						mobile: false,
						title: i18n.t('MainMenu_0009'),
					},
				],
			},
		];

		const menus = [] as JSX.Element[];
		const mobile = isMobile();
		const { permittedItems } = this.props;
		for (const menu of menuTypes) {
			if (
				menu.id &&
				permittedItems.findIndex(e => e === menu.id) === -1
			) {
				continue;
			}
			const items = [] as JSX.Element[];
			for (const item of menu.items) {
				if (mobile && item.mobile === false) {
					continue;
				}
				if (
					menu.id &&
					permittedItems.findIndex(e => e === item.id) === -1
				) {
					continue;
				}
				items.push(
					<ListItem
						key={item.title}
						button={true}
						onClick={item.link}
						disabled={
							typeof item.link === 'undefined' ? true : false
						}
					>
						<img src={item.icon} className={classes.menuIcon} />
						<ListItemText primary={item.title} />
					</ListItem>
				);
			}
			if (items.length > 0) {
				menus.push(
					<List
						key={menu.header}
						component="nav"
						onClick={this.props.closeMainMenu}
					>
						{items}
						<hr />
					</List>
				);
			}
		}

		return <React.Fragment>{menus}</React.Fragment>;
	};

	/**
	 * メニューオープンハンドラ
	 */
	protected handleOpenMainMenu = () => {
		this.props.openMainMenu();
	};

	/**
	 * メニュークローズハンドラ
	 */
	protected handleCloseMainMenu = () => {
		this.props.closeMainMenu();
	};
}

const mapStateToProps = (state: IRootState) => ({
	managerChk: state.session.userAttr.managerChk,
	token: state.session.token,

	open: state.mainMenu.open,
	permittedItems: state.mainMenu.permittedItems,
	tsqWindow: state.mainMenu.tsqWindow,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	checkSession: async (token: string) => {
		const s = ScenarioFactory.createCheckSession(dispatch, token);
		await s.run({});
	},
	closeMainMenu: () => dispatch(openMainMenu({ isOpen: false })),
	fetchMenuModel: (token: string) => {
		const s = ScenarioFactory.createFetchMenuModel(dispatch, token);
		s.run({});
	},
	logout: (token: string, tsqWindow: Window | null, userAttr: IUserAttr) => {
		const s = NavbarScenarioFactory.createLogout(
			dispatch,
			token,
			userAttr.loginType
		);
		s.run({ tsqWindow });
	},
	openMainMenu: () => dispatch(openMainMenu({ isOpen: true })),
	pushHistory: (screen: Screens) => dispatch(push(Routes.getPath(screen))),
	setTsqWindow: (tsqWindow: Window | null) =>
		dispatch(setTsqWindow({ tsqWindow })),
});

// tslint:disable-next-line: no-empty-interface
export interface IMainMenuProps {}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & IMainMenuProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(MainMenu);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/containers/MainMenu.tsx